














import Vue from 'vue';

// TODO: temp to quick fix risk heatmap functionality

export default Vue.extend({
  name: 'RiskTitleCellPresenter',
});
